import React from 'react';
import { Link } from 'react-router-dom';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-xl shadow">
          <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-gray-700 mb-4">
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website. We are committed to protecting your privacy and will only use your personal information in accordance with this policy.
          </p>
          <section className="mb-4">
            <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
            <p className="text-gray-700">We may collect personal information such as names, email addresses, and any other information you provide when you subscribe or contact us.</p>
          </section>
          <section className="mb-4">
            <h2 className="text-xl font-semibold mb-2">How We Use Information</h2>
            <p className="text-gray-700">We use the information to operate, maintain, and provide you with the features of the website, and to communicate with you.</p>
          </section>
          <section className="mb-4">
            <h2 className="text-xl font-semibold mb-2">Contact</h2>
            <p className="text-gray-700">If you have questions about this Privacy Policy, please contact us via the contact page.</p>
          </section>
          <div className="mt-6">
            <Link to="/" className="text-primary-600 hover:underline">Back to Home</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
